var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('text-form-group',{attrs:{"value":_vm.value.value,"name":"value","label":"Value","error":(_vm.errors.value || [])[0]},on:{"input":function($event){return _vm.input('value', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }